import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

import SchoolClassList from '@/domains/school/class-list/main';

export default {
	name: 'LessonPlanningCopy',
	data: () => ({
		model: {},
		klass: {}
	}),
	props: {
		index: {
			type: Number,
			default: null
		}
	},
	components: {
		SchoolClassList
	},
	computed: {
		...mapGetters([
			'getLoggedUser',
			'currentYear',
			'currentTheme',
			'getClass',
			'schoolClassLessonPlan'
		])
	},
	methods: {
		...mapActions([
			'updateSchoolClassLessonPlan',
			'putSchoolClassLessonPlan',
			'copySchoolClassLessonPlan'
		]),
		toggleCopy(index, status) {

			EventBus.$emit('planning:toggle-copy', index, status);

		},
		onSubmitCopy() {

			this.copySchoolClassLessonPlan({
				data: {
					schoolClassId: this.getClass.schoolClassId,
					newSchoolClassId: this.klass.schoolClassId
				},
				themeId: this.currentTheme.schoolThemeId,
				year: this.currentYear,
				userId: this.getLoggedUser.id,
			}).then(() => {

				this.toggleCopy(this.index, false);

				toastr.success(this.$gettext('Planejamento de aula duplicado com sucesso!'));

				EventBus.$emit('school-class-lesson-plan:copied');

			});

		}
	},
	mounted() {

		EventBus.$on('classChanged', (klass) => {

			this.klass = klass.data;

			if (klass.context !== 'LessonPlanningCopy') {
				this.toggleCopy(this.index, false);
			}

		});

	}
};



// WEBPACK FOOTER //
// ./sources/domains/lessons/planning-copy/index.js